import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehouseTransfer as SchemaDeliveryWarehouseTransfer } from '../schemas/DeliveryWarehouseTransfer';
import { type UpdateDeliveryWarehouseTransferRequest as SchemaUpdateDeliveryWarehouseTransferRequest } from '../schemas/UpdateDeliveryWarehouseTransferRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const UpdateDeliveryWarehouseTransferContentType = 'application/json' as const;
export type UpdateDeliveryWarehouseTransferRequest = SchemaUpdateDeliveryWarehouseTransferRequest;
export type UpdateDeliveryWarehouseTransferResponses = LinkCommonErrorResponses & {
    /**
     * @description Warehouse transfer updated
     */
    '200': {
        'application/json': SchemaDeliveryWarehouseTransfer;
    };
};
export type UpdateDeliveryWarehouseTransferResponseSuccess =
    UpdateDeliveryWarehouseTransferResponses['200']['application/json'];
export type UpdateDeliveryWarehouseTransferSearchParams = undefined;
export type UpdateDeliveryWarehouseTransferPathParameters = {
    warehouse_id: string;
    transfer_id: string;
};
export const UpdateDeliveryWarehouseTransferUrl = '/delivery/warehouse/{warehouse_id}/transfers/{transfer_id}' as const;
export const UpdateDeliveryWarehouseTransferMethod = 'PATCH' as const;
export const getUpdateDeliveryWarehouseTransferUrl = (params: UpdateDeliveryWarehouseTransferPathParameters) =>
    UpdateDeliveryWarehouseTransferUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof UpdateDeliveryWarehouseTransferPathParameters) => String(params[param])
    );
